"use strict";
import { UPDATED_CUSTOMER_FORM_VALIDATION_STATE } from "../actions/customer";

import objectAssign from "object-assign";

import { customerInitialState } from "../state/initialState";

function languageProviderReducer(state = customerInitialState, action) {
  let newStatus;
  switch (action.type) {
    case UPDATED_CUSTOMER_FORM_VALIDATION_STATE:
      newStatus = {
        locale: action.locale
      };
      return objectAssign({}, state, newStatus);
    default:
      return state;
  }
}

export default languageProviderReducer;
